import React, { useEffect, useState } from "react";
import { Card, Col, Row, Form, Table, Badge, Button, Spinner } from "react-bootstrap";
import { FaSwimmingPool } from 'react-icons/fa';
import { TbCoins, TbTruckDelivery } from 'react-icons/tb';
import { AiOutlineCheck } from 'react-icons/ai';
import PrivateApi from "../../services/PrivateApiService";
import { useQueryClient } from "react-query";
import EnergoPagination from "../shared/EnergoPagination";
import { FaSquareXmark } from 'react-icons/fa6';
import RangeSlider from 'react-range-slider-input';
import energoLogo from '../../green-logo.png';


/**
 * Invoice Table component
 * 
 * display invoices in html table and allows customer to download them
 * 
 * @param {props} selectedAnlage array of Anlage id and Anlage energo number
 * @param {props} setSelectedAnlage setter for selectedAnlage
 * @param {props} invoices array of filtered Invoices which should be displayed
 * 
 * @returns html table
 */
const InvoiceTable = ({invoices, selectedAnlage, setSelectedAnlage}) => {

    const API = new PrivateApi(); // API calls
    const queryClient = useQueryClient();

    //pagination
    const [maxItemsInPagination, setMaxItemsInPagination] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [currentView, setCurrentView] = useState([]);

    const [downloadBtnHidden, setDownloadBtnHidden] = useState(true); // bool state for show/hide download btn
    const [downloadBtnLoading, setDownloadBtnLoading] = useState(false); // bool state for show loading of download
    const [clearFilterHidden, setClearFilterHidden] = useState(true); // bool state to show/hide filters

    const [selectedInvoices, setSelectedInvoices] = useState([]); // array state of invoices
    const [downloadList, setDownloadList] = useState([]); // array state of objects{'class', 'id'} to be downloaded
    const months = ['1.Januar', '2.Februar', '3.März', '4.April', '5.Mai', '6.Juni', '7.Juli', '8.August', '9.September', '10.Oktober', '11.November', '12.Dezember'];
    const [monthRange, setMonthRange] = useState([1, 12]);
    const [years, setYears] = useState([]); // array state of years to be filtered
    const [types, setTypes] = useState([]); // array state of types to be filtered
    const invClass = ['ENERGO', 'Energielieferant']; // classes of Inovice
    const downloadChoices = ['Ja', 'Noch nicht']; // downlaoded or not to be removed

    // filter vars
    const [selectedClass, setSelectedClass] = useState(""); // selected Invoice class
    const [selectedType, setSelectedType] = useState(""); // selected Invoice type
    const [selectedMonthFrom, setSelectedMonthFrom] = useState(0); // selected month from
    const [selectedMonthTill, setSelectedMonthTill] = useState(0); // selected month till
    const [selectedYear, setSelectedYear] = useState(0); // selected year
    const [selectedDownload, setSelectedDownload] = useState(""); // selected downloaded


    // initial Effect when invoices gets data
    useEffect(() => {
        if (invoices && invoices.length > 0) {
            //setSelectedInvoices(invoices.sort((a, b) => new Date(a.x_rechnungsdatum ? a.x_rechnungsdatum : a.x_eingangsdatum ? a.x_eingangsdatum : a.x_datum_tzb_einzug) - new Date(b.x_rechnungsdatum ? b.x_rechnungsdatum : b.x_eingangsdatum ? b.x_eingangsdatum : b.x_datum_tzb_einzug)).reverse());
            checkActiveFilters();
            setCurrentPage(1);

            setYears([]);
            var year_list = [];
            var types_list = [];
            invoices?.map(i => {
                var year = i.x_rechnungsdatum ? i.x_rechnungsdatum.slice(0, 4) : i.x_eingangsdatum ? i.x_eingangsdatum.slice(0, 4) : i.x_datum_tzb_einzug.slice(0, 4);
                var index = year_list.findIndex(x => x === Number(year));
                if (index === -1) year_list.push(Number(year));
                //var type = i.x_file_mahnung_name && x_file_mahnung_name !== 'False' ? 'Mahnung' : (i.x_file_stornorechnung_name && x_file_stornorechnung_name) || i.x_is_storniert ? 'Stornorechnung' :  i.x_is_final_invoice ? 'Endabrechnung' : i.x_datum_tzb_einzug ? 'Vorschreibung' : i.x_rechnungsart;
                var type = "";

                if (i.x_file_mahnung_name !== undefined && i.x_file_mahnung_name !== 'False') type = "Mahnung";
                else if ((i.x_file_stornorechnung_name !== undefined && i.x_file_stornorechnung_name !== 'False') || i.x_is_storniert === true) type = "Stornorechnung";
                else if (i.x_is_final_invoice !== undefined && i.x_is_final_invoice === true) type = "Endabrechnung";
                else if (i.x_datum_tzb_einzug !== undefined) type = "Vorschreibung";
                else if (i.x_rechnungsart !== undefined) type = i.x_rechnungsart;
                else type = "Abrechnung";

                index = types_list.findIndex(x => type === x);
                if (index === -1 && type !== "") types_list.push(type);
                return null;
            });
            setYears(year_list.reverse());
            setTypes(types_list.reverse());
        } else {
            setSelectedInvoices([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invoices])



    // Function to check all checkboxes
    const checkAll = (value) => {
        var checkboxes = document.getElementsByClassName('form-check-input');
        if (value) {
            var d_list = [];
            for (var i = 1; i < checkboxes.length; i++) {
                checkboxes[i].checked = true;
                d_list.push({ "type": checkboxes[i].id.split(":")[0], "id": checkboxes[i].id.split(":")[1] });
            }
            setDownloadList(d_list);
            setDownloadBtnHidden(false);
        }
        else {
            for (var x = 1; x < checkboxes.length; x++) {
                checkboxes[x].checked = false;
            }
            setDownloadBtnHidden(true);
            setDownloadList([]);
        }
    }



    // Function to check single checkbox
    const checkSingle = (value) => {
        var d_list = [...downloadList];
        if (value.target.checked) {
            var obj = { "type": value.target.id.split(":")[0], "id": value.target.id.split(":")[1] };
            d_list = downloadList;
            d_list.push(obj);
            setDownloadList(d_list);
            setDownloadBtnHidden(false);
        } else {
            d_list = downloadList.filter(d => d.id !== value.target.id.split(":")[1]);
            setDownloadList(d_list);
            if (d_list.length === 0) setDownloadBtnHidden(true);
        }
    }



    const checkSelectedCheckboxes = () => {
        var checkboxes = document.getElementsByClassName('form-check-input')
        if (downloadList.length > 0) {
            for (let i = 0; i < downloadList.length; i++) {
                Array.prototype.filter.call(
                    checkboxes,
                    c => c.id === `${downloadList[i].type}:${downloadList[i].id}` ?
                        c.checked = true : null
                );
            }
        }
    }


    // Function to clear all filters
    const clearAllFilters = () => {
        setSelectedClass("");
        setSelectedType("");
        setSelectedMonthFrom(0);
        setSelectedMonthTill(0);
        setSelectedYear(0);
        setSelectedDownload("");
        setClearFilterHidden(true);
        setSelectedInvoices(invoices)
        checkSelectedCheckboxes();
    }


    useEffect(() => {
        if (selectedInvoices.length > maxItemsInPagination ) {
            var start = (currentPage -1) * maxItemsInPagination;
            var end = currentPage * maxItemsInPagination;
            setCurrentView(selectedInvoices.slice(start, end));
        } else {
            setCurrentView(selectedInvoices);
        }
    }, [maxItemsInPagination])

    useEffect(() => {
        if (selectedInvoices.length > maxItemsInPagination) {
            var start = (currentPage -1) * maxItemsInPagination;
            var end = currentPage * maxItemsInPagination;
            setCurrentView(selectedInvoices.slice(start, end));
        } else {
            setCurrentView(selectedInvoices);
        }
    });
    /**
     * Effect for filters
     */
    useEffect(() => {
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedClass])

    useEffect(() => {
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedType])

    useEffect(() => {
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [monthRange])

    useEffect(() => {
        if (Number(selectedMonthTill) < Number(selectedMonthFrom)) setSelectedMonthFrom(selectedMonthTill);
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMonthTill])

    useEffect(() => {
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedYear])

    useEffect(() => {
        checkActiveFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDownload])



    // Function to check which filter was applied
    const checkActiveFilters = () => {
        var count = 0;
        var initialInvoices = invoices;
        var filtered = null;
        if (selectedClass !== "") {
            if (selectedClass === 'ENERGO') {
                filtered = initialInvoices.filter(x => x.x_rechnungsart);
                initialInvoices = filtered;
            }
            if (selectedClass === 'Energielieferant') {
                filtered = initialInvoices.filter(x => x.x_abrechnungszeitraum_von || x.x_datum_tzb_einzug);
                initialInvoices = filtered;
            }
            count++;
        }
        if (selectedType !== "") {
            if (selectedType === 'Mahnung') filtered = initialInvoices.filter(x => x.x_file_mahnung_name && x.x_file_mahnung_name !== 'False');
            else if (selectedType === 'Stornorechnung') filtered = initialInvoices.filter(x => x.x_rechnungsart === "Stornorechnung" || (x.x_file_stornorechnung_name && x.x_file_stornorechnung_name !== 'False'));
            else if (selectedType === 'Endabrechnung') filtered = initialInvoices.filter(x => x.x_is_final_invoice === true || x.x_rechnungsart === 'Endabrechnung');
            else if (selectedType === 'Vorschreibung') filtered = initialInvoices.filter(x => x.x_datum_tzb_einzug);
            else if (selectedType === 'Abrechnung') filtered = initialInvoices.filter(x => (x.x_file_mahnung_name === "False" && x.x_file_stornorechnung_name === "False" && x.x_file_abrechnung_name !== "False" && x.x_is_final_invoice === false) || x.x_rechnungsart === "Abrechnung")
            else filtered = initialInvoices.filter(x => x.x_rechnungsart === selectedType);
            initialInvoices = filtered;
            count++;
        }

            filtered = initialInvoices.filter(
                x =>
                    Number(x.create_date.split('-')[1]) > monthRange[0] && Number(x.create_date.split('-')[1]) <= monthRange[1] 
            );
            initialInvoices = filtered;


        if (selectedYear !== 0) {
            filtered = initialInvoices.filter(
                x =>
                    x.x_rechnungsdatum ? Number(x.x_rechnungsdatum.slice(0, 4)) === Number(selectedYear)
                        :
                        x.x_eingangsdatum ? Number(x.x_eingangsdatum.slice(0, 4)) === Number(selectedYear)
                            :
                            Number(x.x_datum_tzb_einzug.slice(0, 4)) === Number(selectedYear)
            );
            initialInvoices = filtered;
            count++;
        }
        if (selectedDownload !== "") {
            if (selectedDownload === 'Ja') {
                filtered = initialInvoices.filter(x => x.x_datum_download !== 'False' || (x.x_file_stornorechnung_name !== undefined && x.x_file_stornorechnung_name !== 'False' && x.x_datum_download_storno !== 'False') || (x.x_file_mahnung_name !== undefined && x.x_file_mahnung_name !== 'False' && x.x_datum_download_mahnung !== 'False'));
            } else {
                filtered = initialInvoices.filter(x => x.x_datum_download === 'False' || (x.x_file_stornorechnung_name !== undefined && x.x_file_stornorechnung_name !== 'False' && x.x_datum_download_storno === 'False') || (x.x_file_mahnung_name !== undefined && x.x_file_mahnung_name !== 'False' && x.x_datum_download_mahnung === 'False'));
            }
            initialInvoices = filtered;
            count++;
        }
        if (count > 0) setClearFilterHidden(false);
        else setClearFilterHidden(true);
        setSelectedInvoices(initialInvoices);
        checkSelectedCheckboxes();
    }


    // Hanlder to download zips
    const downloadBtnHandler = () => {
        setDownloadBtnLoading(true);
        console.log(downloadList.length);
        API.post_InvoiceDownload(downloadList)
            .then(res => {
                let data = res.data;
                queryClient.invalidateQueries("GET_BUILDING_INVOICES");
                setDownloadBtnLoading(false);
                if (data.files === undefined) {
                    const linkSource = `data:application/pdf;base64,${data.file}`;
                    const fileName = data.name + '.pdf';
                    const downloadLink = document.createElement('a');

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                } else {
                    if (data.files.abrechnungen !== undefined) {
                        const linkSource = `data:application/zip;base64,${data.files.abrechnungen}`;
                        const fileName = data.files.abrechnungen_name;
                        const downloadLink = document.createElement('a');

                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    }
                    if (data.files.poolrechnungen !== undefined) {
                        const linkSource = `data:application/zip;base64,${data.files.poolrechnungen}`;
                        const fileName = data.files.poolrechnungen_name;
                        const downloadLink = document.createElement('a');

                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    }
                    if (data.files.vorschreibungen !== undefined) {
                        const linkSource = `data:application/zip;base64,${data.files.vorschreibungen}`;
                        const fileName = data.files.vorschreibungen_name;
                        const downloadLink = document.createElement('a');

                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    }
                }
            })
    }

     // Function to display Range as string
     const getDateRange = () => {
        let date1 = new Date();
        let date2 = new Date();
        date1.setMonth(monthRange[0] - 1);
        date2.setMonth(monthRange[1] - 1);
        let from = date1.toLocaleDateString('DE-de', { month: 'long' });
        let till = date2.toLocaleDateString('DE-de', { month: 'long' })
        return `${from} - ${till}`;
    }


    // GUI
    return (
        <>
            <Row className="mt-5 text-start align-items-center">
                <Col xs="12" md="8" xl="8">
                    <Row>
                        {clearAllFilters ?
                            <Col xs="12" md="6" xl="6" className="text-start">
                                {!clearFilterHidden ? 
                                    <a onClick={e => { e.preventDefault(); clearAllFilters() }} href="/flters/reset" className="clear-filters">
                                        <FaSquareXmark size="30" />
                                        &nbsp; Aktuelle Filter zurücksetzen
                                    </a>
                                :null}
                            </Col>
                            :null
                        }
                        <Col xs="12" md={clearFilterHidden? "12":"6"} xl={clearFilterHidden? "12":"6"}>
                            {selectedAnlage && selectedAnlage.length > 0 ? (
                                <a onClick={e => { e.preventDefault(); setSelectedAnlage([]) }} href="/filters/anlage/clear" className="clear-filters">
                                    <FaSquareXmark size={30} />
                                    &nbsp; Ausgewählte Anlage {selectedAnlage[1]}
                                </a>
                            ) : null}
                        </Col>
                    </Row>
                </Col>
                <Col xs="12" md="4" xl="4" className="text-end">
                    <div className="d-inline-block">
                        <Form.Select defaultValue={maxItemsInPagination} onChange={e => setMaxItemsInPagination(e.target.value)} >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </Form.Select>
                    </div>
                    <small style={{marginLeft: "5px"}}>pro Seite</small>

                </Col>
            </Row>


            <Card style={{ borderRadius: "15px", borderBottom: "3px solid #a2c13f", borderLeft: "3px solid #a2c13f" }} className="mt-3 shadow-lg">
                <Card.Header>
                    <Row className="align-items-center pt-2 pb-2">
                        <Col xs="6" md="6" xl="2">
                            <div className="dropdown">
                                <button className="btn btn-link drop-energo dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedClass === '' ? 'Dokument von' : selectedClass === 'Energielieferant' ? 'Energielieferant' : selectedClass === 'ENERGO' ? 'ENERGO' : null}
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    {invClass?.map((ic, index) => (
                                        <li key={'ic' + index}>
                                            {ic === selectedClass ?
                                                <a onClick={e => { e.preventDefault(); setSelectedClass("") }} href={`rechnung/von/${ic}`} className="dropdown-item">
                                                    <Row>
                                                        <Col xs="2">
                                                            <AiOutlineCheck />
                                                        </Col>
                                                        {ic === "ENERGO" ?
                                                            <Col xs="10">
                                                                ENERGO
                                                            </Col>
                                                            : ic === "Energielieferant" ?
                                                                <Col xs="10">
                                                                    Energielieferant
                                                                </Col>
                                                                : null
                                                        }
                                                    </Row>
                                                </a>
                                                :
                                                ic === "ENERGO" ?
                                                    <a 
                                                        onClick={e => { e.preventDefault(); setSelectedClass(ic) }} 
                                                        href={`rechnung/von/${ic}`} 
                                                        className="dropdown-item">
                                                            <Row>
                                                                <Col xs="3" style={{padding: "0 1px"}}>
                                                                    <img className="img-fluid" src={energoLogo} width="40" alt="" />
                                                                </Col>
                                                                <Col xs="8" style={{padding: 0}}>
                                                                    ENERGO
                                                                </Col>
                                                            </Row>
                                                    </a>
                                                    :
                                                    ic === 'Energielieferant' ?
                                                        <a 
                                                            onClick={e => { e.preventDefault(); setSelectedClass(ic) }} 
                                                            href={`rechnung/von/${ic}`} 
                                                            className="dropdown-item">
                                                                <Row>
                                                                    <Col xs="3" style={{padding: "0 5px"}}>
                                                                        <TbTruckDelivery className="text-primary" size="22" />
                                                                    </Col>
                                                                    <Col xs="8" style={{padding: 0}}>
                                                                        Energielieferant
                                                                    </Col>
                                                                </Row>
                                                        </a>
                                                        :
                                                        null
                                            }
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                        <Col xs="6" md="6" xl="3">
                            <div className="dropdown">
                                <button className="btn btn-link drop-energo dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedType === '' ? 'Rechnungsart' : selectedType}
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    {types?.map((t, index) => (
                                        <li key={'type' + index}>
                                            {selectedType === t ?
                                                <a onClick={e => { e.preventDefault(); setSelectedType("") }} href={`typ/${t}`} className="dropdown-item">
                                                    <Row>
                                                        <Col xs="2">
                                                            <AiOutlineCheck />
                                                        </Col>
                                                        <Col xs="10">
                                                            {t}
                                                        </Col>
                                                    </Row>
                                                </a>
                                                :
                                                <a onClick={e => { e.preventDefault(); setSelectedType(t) }} href={`types/${t}`} className="dropdown-item">{t}</a>
                                            }
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                        <Col xs="6" md="4" xl="3">
                            <p className="text-energo mt-1">{getDateRange()}</p>
                            <RangeSlider 
                                value={monthRange} onInput={setMonthRange}
                                step={1}
                                min={1}
                                max={12}
                            />
                        </Col>

                        <Col xs="6" md="4" xl="2">
                            <div className="dropdown">
                                <button className="btn btn-link drop-energo dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedYear === 0 ? "Jahr" : selectedYear}
                                </button>
                                <ul className="dropdown-menu">
                                    {years.map(y => (
                                        <li key={'year' + y}>
                                            {selectedYear === y ?
                                                <a onClick={e => { e.preventDefault(); setSelectedYear(0) }} href="reset/jahr" className="dropdown-item">
                                                    <Row>
                                                        <Col xs="4">
                                                            <AiOutlineCheck />
                                                        </Col>
                                                        <Col xs="8">{y}</Col>
                                                    </Row>
                                                </a>
                                                :
                                                <a onClick={e => { e.preventDefault(); setSelectedYear(y) }} href={`/filters/jahr/${y}`} className="dropdown-item text-center">{y}</a>
                                            }
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                        <Col xs="12" md="4" xl="2" hidden={!downloadBtnHidden}>
                            <div className="dropdown">
                                <button className="btn btn-link drop-energo dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedDownload === "" ? "Downloaded" : selectedDownload}
                                </button>
                                <ul className="dropdown-menu">
                                    {downloadChoices.map((d, index) => (
                                        <li key={'downloaded' + index}>
                                            {selectedDownload === d ?
                                                <a onClick={e => { e.preventDefault(); setSelectedDownload("") }} href="/filtes/download/reset" className="dropdown-item">
                                                    <Row>
                                                        <Col xs="4">
                                                            <AiOutlineCheck />
                                                        </Col>
                                                        <Col xs="8">{d}</Col>
                                                    </Row>
                                                </a>
                                                :
                                                <a onClick={e => { e.preventDefault(); setSelectedDownload(d) }} href={`/filters/download/${d}`} className="dropdown-item text-center">{d}</a>
                                            }
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </Col>
                        <Col xs="12" md="6" xl="2" hidden={downloadBtnHidden}>
                            {downloadBtnLoading ?
                                <>
                                    <Spinner className="text-energo" />
                                    <p>Download wird vorbereitet</p>
                                </>
                                :
                                <Button className="btn-energo" onClick={() => downloadBtnHandler()}>Download</Button>
                            }
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body>
                    <Table hover responsive>
                        <thead>
                            <tr>
                                <th><Form.Check type="checkbox" onChange={e => checkAll(e.target.checked)} /></th>
                                <th>Von</th>
                                <th>Rechnungsart</th>
                                <th>Datum</th>
                                <th>Anlage</th>
                                <th>Brutto</th>
                                <th>Downloaded</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedInvoices && selectedInvoices.length > 0 ? currentView.map(pr => (
                                <>
                                    <tr key={pr.id} className="align-items-center animate__animated animate__slideInRight">
                                        <td>
                                            <Form.Check type="checkbox"
                                                id={pr.x_rechnungsdatum ? `poolrechnung:${pr.id}` : pr.x_eingangsdatum ? `abrechnung:${pr.id}` : `vorschreibung:${pr.id}`}
                                                onChange={e => checkSingle(e)} />
                                        </td>
                                        <td>
                                            {
                                                pr.x_rechnungsdatum ? <FaSwimmingPool className="text-energo" size="30" />
                                                    :
                                                    pr.x_eingangsdatum ? <TbTruckDelivery className="text-primary" size="30" />
                                                        :
                                                        <TbCoins className="text-warning" size="30" />
                                            }
                                        </td>
                                        <td>
                                            {
                                                pr.x_rechnungsart ? pr.x_rechnungsart + ' ENERGO'
                                                    :
                                                    pr.x_is_final_invoice ? 'Endrechnung Energie'
                                                        :
                                                        pr.x_datum_tzb_einzug ? 'Vorschreibung Energie'
                                                            : 'Abrechnung Energie'
                                            }
                                            {(pr.x_file_stornorechnung_name && pr.x_file_stornorechnung_name !== 'False') || pr.x_is_storniert ?
                                                <small><Badge bg="danger" style={{ marginLeft: "5px" }} >storniert</Badge></small>
                                                : null}
                                        </td>
                                        <td>
                                            {
                                                pr.x_rechnungsdatum ? new Date(pr.x_rechnungsdatum).toLocaleDateString('DE-de')
                                                    :
                                                    pr.x_eingangsdatum ? new Date(pr.x_eingangsdatum).toLocaleDateString('DE-de')
                                                        :
                                                        new Date(pr.create_date).toLocaleDateString('DE-de')
                                            }
                                        </td>
                                        <td>{pr.x_anlage_id !== 'False' ? pr.x_anlage_id.split("'")[1].split('_')[0].replace('000', '') : null}</td>
                                        <td>{pr.x_poolbeitrag_summe_lastschrift ? pr.x_poolbeitrag_summe_lastschrift.toFixed(2) : pr.x_energiekosten_netto ? (pr.x_energiekosten_netto * 1.2).toFixed(2) : Number(pr.x_teilvorschreibung_brutto).toFixed(2)} €</td>
                                        <td>
                                            {pr.x_datum_download !== 'False' ?
                                                <AiOutlineCheck className="text-energo" /> : <i className="fa-solid fa-xmark text-danger"></i>
                                            }
                                        </td>
                                    </tr>
                                    {pr.x_file_mahnung_name && pr.x_file_mahnung_name !== 'False' ?
                                        <tr key={`mahnung:${pr.id}`} className="animate__animated animate__slideInRight">
                                            <td>
                                                <Form.Check type="checkbox"
                                                    id={pr.x_rechnungsdatum ? `poolrechnung:${pr.id}` : pr.x_eingangsdatum ? `abrechnung:${pr.id}` : `vorschreibung:${pr.id}`}
                                                    onChange={e => checkSingle(e)} />
                                            </td>
                                            <td>
                                                {
                                                    pr.x_rechnungsdatum ? <FaSwimmingPool className="text-energo" size="30" />
                                                        :
                                                        pr.x_eingangsdatum ? <TbTruckDelivery className="text-primary" size="30" />
                                                            :
                                                            <TbCoins className="text-warning" size="30" />
                                                }
                                            </td>
                                            <td>Mahnung Energie</td>
                                            <td>
                                                {
                                                    pr.x_rechnungsdatum ? new Date(pr.x_rechnungsdatum).toLocaleDateString('DE-de')
                                                        :
                                                        pr.x_eingangsdatum ? new Date(pr.x_eingangsdatum).toLocaleDateString('DE-de')
                                                            :
                                                            new Date(pr.create_date).toLocaleDateString('DE-de')
                                                }
                                            </td>
                                            <td>{pr.x_anlage_id !== 'False' ? pr.x_anlage_id.split("'")[1].split('_')[0].replace('000', '') : null}</td>
                                            <td>{pr.x_poolbeitrag_summe_lastschrift ? pr.x_poolbeitrag_summe_lastschrift.toFixed(2) : pr.x_energiekosten_netto ? (pr.x_energiekosten_netto * 1.2).toFixed(2) : Number(pr.x_teilvorschreibung_brutto).toFixed(2)} €</td>
                                            <td>
                                                {pr.x_datum_download_mahnung !== 'False' ?
                                                    <AiOutlineCheck className="text-energo" /> : <i className="fa-solid fa-xmark text-danger"></i>
                                                }
                                            </td>
                                        </tr>
                                        : null}
                                    {(pr.x_file_stornorechnung_name && pr.x_file_stornorechnung_name !== 'False') ?
                                        <tr key={`storno:${pr.id}`} className="animate__animated animate__slideInRight">
                                            <td>
                                                <Form.Check type="checkbox"
                                                    id={pr.x_rechnungsdatum ? `poolStorno:${pr.id}` : pr.x_eingangsdatum ? `abrStorno:${pr.id}` : `vorStorno:${pr.id}`}
                                                    onChange={e => checkSingle(e)} />
                                            </td>
                                            <td>
                                                {
                                                    pr.x_rechnungsdatum ? <FaSwimmingPool className="text-energo" size="30" />
                                                        :
                                                        pr.x_eingangsdatum ? <TbTruckDelivery className="text-primary" size="30" />
                                                            :
                                                            <TbCoins className="text-warning" size="30" />
                                                }
                                            </td>
                                            <td>Stornorechnung {pr.x_rechnungsdatum ? ' ENERGO' : ' Energie'}</td>
                                            <td>
                                                {
                                                    pr.x_rechnungsdatum ? new Date(pr.x_rechnungsdatum).toLocaleDateString('DE-de')
                                                        :
                                                        pr.x_eingangsdatum ? new Date(pr.x_eingangsdatum).toLocaleDateString('DE-de')
                                                            :
                                                            new Date(pr.create_date).toLocaleDateString('DE-de')
                                                }
                                            </td>
                                            <td>{pr.x_anlage_id !== 'False' ? pr.x_anlage_id.split("'")[1].split('_')[0].replace('000', '') : null}</td>
                                            <td>{pr.x_poolbeitrag_summe_lastschrift ? pr.x_poolbeitrag_summe_lastschrift.toFixed(2) : pr.x_energiekosten_netto ? (pr.x_energiekosten_netto * 1.2).toFixed(2) : Number(pr.x_teilvorschreibung_brutto).toFixed(2)} €</td>
                                            <td>
                                                {pr.x_datum_download_storno !== 'False' ?
                                                    <AiOutlineCheck className="text-energo" /> : <i className="fa-solid fa-xmark text-danger"></i>
                                                }
                                            </td>
                                        </tr>
                                        : null}
                                </>
                            )) :
                                <tr>
                                    <td colSpan={7}>Keine Daten gefunden...</td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                    <div className="text-center" style={{ marginTop: "43px" }} hidden={selectedInvoices.length <= maxItemsInPagination}>
                        <EnergoPagination max={Math.ceil(selectedInvoices.length / maxItemsInPagination)} current={currentPage} select={setCurrentPage} />
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

export default InvoiceTable;